export const cameraCaptureText = {
  title: { key: 'attachment_take_photo', fallback: { en: 'Take a photo', he: 'צילום תמונה' } },
  preview: { key: 'camera_preview', fallback: { en: 'Camera preview', he: 'תצוגה מקדימה של המצלמה' } },
  opening: {
    key: 'camera_opening',
    fallback: {
      en: 'Opening camera… Allow camera access when your browser asks.',
      he: 'פותחים את המצלמה… יש לאשר גישה למצלמה כשהדפדפן מבקש.',
    },
  },
  error: {
    key: 'camera_capture_error',
    fallback: {
      en: 'Could not open the camera or capture a photo. Check camera access in your browser and try again.',
      he: 'לא ניתן לפתוח את המצלמה או לצלם. בדקו את הרשאות המצלמה בדפדפן ונסו שוב.',
    },
  },
  unsupported: {
    key: 'camera_capture_unsupported',
    fallback: {
      en: 'Camera capture is unavailable in this browser. You can upload a photo from your computer.',
      he: 'צילום אינו זמין בדפדפן הזה. ניתן להעלות תמונה מהמחשב.',
    },
  },
  cancel: { key: 'cancel', fallback: { en: 'Cancel', he: 'ביטול' } },
  retry: { key: 'try_again', fallback: { en: 'Try again', he: 'ניסיון נוסף' } },
  capture: { key: 'camera_capture_photo', fallback: { en: 'Take photo', he: 'צילום' } },
  close: { key: 'camera_close', fallback: { en: 'Close camera', he: 'סגירת המצלמה' } },
}
